/**
 * Company → booking-site domain, for building customer-facing links from admin.
 *
 * COPY of softcar-booking-frontend/src/lib/domainCompanyMap.ts (DOMAIN_COMPANY_MAP). The booking
 * site picks the company from the domain it is served on, so a link to a company's booking site
 * must use one of that company's domains. Keep this in sync by hand: when a company is onboarded,
 * add its domain(s) here as well as in the booking site.
 */
export const DOMAIN_COMPANY_MAP = {
    "booking-public.netlify.app": "6b0516fa-e370-49ba-a79c-2487863f6e13",
    "softcar-booking-prod.netlify.app": "6b0516fa-e370-49ba-a79c-2487863f6e13",
    "softcar-booking-fe-dev.netlify.app": "6b0516fa-e370-49ba-a79c-2487863f6e13",
    "softcar-agent.netlify.app": "6b0516fa-e370-49ba-a79c-2487863f6e13",
    "softcar-public-new.netlify.app": "6b0516fa-e370-49ba-a79c-2487863f6e13",
    "localhost:3010": "6b0516fa-e370-49ba-a79c-2487863f6e13",
    "localhost:3000": "6b0516fa-e370-49ba-a79c-2487863f6e13",
    "wowwowcarrental.com": "8fcc0402-02a8-42f1-a6b9-19f826b5e832",
    "728exotic.com": "3953b3f1-c38c-4ef0-957b-5c3c00e3d5a4",
    "www.728exotic.com": "3953b3f1-c38c-4ef0-957b-5c3c00e3d5a4",
    "rentexoticsnc.com": "51b4f4ba-7149-4529-a76a-7badac4ebc30",
    "www.rentexoticsnc.com": "51b4f4ba-7149-4529-a76a-7badac4ebc30",
    "booking-public-dev.netlify.app": "6b0516fa-e370-49ba-a79c-2487863f6e13",
    "rentufs.com": "ed4b8716-4135-4462-8816-d668f7c94cca",
    "www.rentufs.com": "ed4b8716-4135-4462-8816-d668f7c94cca",
    "www.drivenowrental.com": "ddd1a835-5e69-4f71-9ecb-ebf691af8306",
    "drivenowrental.com": "ddd1a835-5e69-4f71-9ecb-ebf691af8306",
    "cottmanautorental.com": "9b771224-4078-44d0-8400-9c1a24b91219",
    "www.cottmanautorental.com": "9b771224-4078-44d0-8400-9c1a24b91219",
    "batcityrentals.com": "03ae7286-2632-4873-95c5-ba3cd154d88e",
    "www.batcityrentals.com": "03ae7286-2632-4873-95c5-ba3cd154d88e",
    "silahrentals.com": "f3bdad85-9505-4703-b10d-32e95347e972",
    "www.silahrentals.com": "f3bdad85-9505-4703-b10d-32e95347e972",
    "drivezonerentals.com": "5367d195-b6a4-4dd0-ad19-e17077daf94f",
    "www.drivezonerentals.com": "5367d195-b6a4-4dd0-ad19-e17077daf94f",
    "capsacar.com": "f42f885e-9275-4cf8-ad90-ae199ec9b631",
    "www.capsacar.com": "f42f885e-9275-4cf8-ad90-ae199ec9b631",
    "topfloorglobal.net": "df5fd89b-588d-4e05-9ae1-396a0f4e78ae",
    "www.topfloorglobal.net": "df5fd89b-588d-4e05-9ae1-396a0f4e78ae",
    "lowdownsrentals.com": "4eaf2699-5c3c-4cc2-8d3a-112f347dedb3",
    "www.lowdownsrentals.com": "4eaf2699-5c3c-4cc2-8d3a-112f347dedb3",
    "ditreyenterprises.com": "145e66a9-86c0-4b76-8a03-6d488a50f362",
    "www.ditreyenterprises.com": "145e66a9-86c0-4b76-8a03-6d488a50f362",
    "drivar.net": "0db054cd-d657-471f-9692-90c931d525d7",
    "www.drivar.net": "0db054cd-d657-471f-9692-90c931d525d7",
    "royalusedrentals.com": "1f7c9015-f1b1-45a8-aacf-8e7981f5eca1",
    "www.royalusedrentals.com": "1f7c9015-f1b1-45a8-aacf-8e7981f5eca1",
    "colecapitalgroup.com": "163291aa-1c9e-4ab7-8490-ca57494c82a4",
    "www.colecapitalgroup.com": "163291aa-1c9e-4ab7-8490-ca57494c82a4",
    "m2mrentals.co": "b8cf02ae-ce16-44c0-940b-9626e79c4553",
    "www.m2mrentals.co": "b8cf02ae-ce16-44c0-940b-9626e79c4553",
    "sugarcarrental.com": "300ac938-fa3e-487b-9dd8-6bcb2f3f0968",
    "www.sugarcarrental.com": "300ac938-fa3e-487b-9dd8-6bcb2f3f0968",
    "ac2gobooking.club": "c511bfab-5df5-46b2-9e51-4505f9134f58",
    "www.ac2gobooking.club": "c511bfab-5df5-46b2-9e51-4505f9134f58",
    "simonsselect.com": "7ffa5449-2ade-48c7-9739-6b6a518725f0",
    "www.simonsselect.com": "7ffa5449-2ade-48c7-9739-6b6a518725f0",
    "gentleautorentals.com": "f568ed20-f37e-4c6a-bf13-0f5ca7e01a5f",
    "www.gentleautorentals.com": "f568ed20-f37e-4c6a-bf13-0f5ca7e01a5f",
};

const isLocalHost = (host) => host.startsWith("localhost") || host.startsWith("127.0.0.1");

const toOrigin = (host) => `${isLocalHost(host) ? "http" : "https"}://${host}`;

const hostOf = (url) => {
    try {
        return new URL(url).host.toLowerCase();
    } catch {
        return "";
    }
};

/**
 * The booking-site origin to use for a company, or null when none is mapped.
 *
 * If the configured booking site (REACT_APP_BOOKING_AGENT_URL / _PUBLIC_URL) belongs to this
 * company, that wins, which is how local development and the shared test sites pick the right
 * one. Otherwise the company's own domain is used, preferring the bare domain over "www." and
 * never a localhost entry.
 */
export const getBookingSiteOrigin = (companyId) => {
    if (!companyId) return null;

    const configured = [process.env.REACT_APP_BOOKING_AGENT_URL, process.env.REACT_APP_BOOKING_PUBLIC_URL]
        .map(hostOf)
        .find((host) => host && DOMAIN_COMPANY_MAP[host] === companyId);
    if (configured) return toOrigin(configured);

    const hosts = Object.keys(DOMAIN_COMPANY_MAP).filter(
        (host) => DOMAIN_COMPANY_MAP[host] === companyId && !isLocalHost(host),
    );
    const preferred = hosts.find((host) => !host.startsWith("www.")) || hosts[0];
    return preferred ? toOrigin(preferred) : null;
};
